/* eslint-disable */
export default {
  save: 'Tallenna',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
